export enum ValueDepreciationScenario {
  Low = 'Low',
  Normal = 'Normal',
  High = 'High',
}
